import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from '../services/baseurl.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PoiDbService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  getTenants(env: string): Observable<Array<MinimalTenant>> {
    return this.http.get<Array<MinimalTenant>>(`${this.baseurlService.getBaseUrl()}/poi/tenants/${env}`);
  }

  getApplicationGroups(env: string): Observable<Array<MinimalApplicationGroup>> {
    return this.http.get<Array<MinimalApplicationGroup>>(`${this.baseurlService.getBaseUrl()}/poi/applicationGroups/${env}`);
  }

  getApplicationConfigurations(env: string, tenant: number): Observable<Array<MinimalApplicationConfiguration>> {
    return this.http.get<Array<MinimalApplicationConfiguration>>(`${this.baseurlService.getBaseUrl()}/poi/applicationconfigurations/${env}/tenant/${tenant}`);
  }

  getDatabase(env: string, tenantGroup: string, module: string): Observable<MinimalDatabaseRetailConnection> {
    return this.http.get<MinimalDatabaseRetailConnection>(`${this.baseurlService.getBaseUrl()}/poi/database/${env}/tenantGroup/${tenantGroup}/module/${module}`);
  }

  getDatabaseCountry(env: string, countryIso3: string, module: string): Observable<MinimalDatabaseRetailConnection> {
    return this.http.get<MinimalDatabaseRetailConnection>(`${this.baseurlService.getBaseUrl()}/poi/database/${env}/country/${countryIso3}/module/${module}`);
  }

  getLegacyTenantDatabase(env: string, tenant: number): Observable<LegacyTenantDbConnection> {
    return this.http.get<LegacyTenantDbConnection>(`${this.baseurlService.getBaseUrl()}/poi/database/${env}/tenant/${tenant}/allRepoDb`);
  }

  getApplicationStatus(env: string, application:string): Observable<ApplicationStatus> {
    return this.http.get<ApplicationStatus>(`${this.baseurlService.getBaseUrl()}/poi/applicationStatus/${env}/application/${application}`);
  }
}


export interface MinimalTenant {
  id: number;
  name: string;
  state: string;
  tenantGroup: MinimalTenantGroup;
  readableVersion: string;
  timezone: string;
  country: MinimalCountry;
  defaultLanguage: string;
  accessible: boolean;
  assignedApplications: Array<string>;
  productFamilies: Array<string>;
  maintenance: boolean;
}

export interface MinimalTenantGroup {
  uid: string,
  name: string,
  matchCode: string,
  sharedDatabaseConfigId: number
  countryUid: string
}

export interface MinimalCountry {
  uid: string,
  iso3Code: string,
  iso2Code: string,
  name: string,
  defaultLanguage: string
}

export interface MinimalApplication {
  name: string,
  type: string,
  url: string,
}

export interface MinimalApplicationGroup {
  id: number,
  name: string,
  applications: Array<string>,
}

export interface MinimalApplicationConfiguration {
  name: string,
  id: string,
  displayName: string
  displayNameKey: string
  internalUrl: string
  externalUrl: string,
  readableVersion: string
  releaseVersion: string
  technicalVersion: string
  isSingleVersion: boolean
  commitId: string
  buildTimestamp: string
  scope: Array<string>,
  appSwitcher: Array<string>,
  useDashboard: boolean
  hasIntro: boolean
  entryPoints: Map<string, string>,
  serviceDependencies: Array<string>,
  externalDependencies: Array<string>,
  external: boolean
  productFamilies: Array<string>,
  providesMenu: boolean
}

export interface MinimalDatabaseRetailConnection {
  id: number;
  connectionString: string,
  dbmsType: string,
  minPoolSize: number,
  maxPoolSize: number,
  maxIdleTime: number,
  user: MinimalDatabaseUser,
}

export interface MinimalDatabaseUser {
  username: string,
  password: string,
  applicationUsername: string,
  applicationPassword: string,
}

export interface LegacyTenantDbConnection {
  id: number,
  username: string,
  password: string,
  url: string,
  driver: string,
  minPoolSize: number,
  maxPoolSize: number,
  maxIdleTime: number,
  dbVersion: string,
  dbLocale: string,
  market: string,
  connectionName: string,
  updatePriority: string,

  usernameSO: string,
  passwordSO: string,

  sharedDatabase: LegacyTenantDbConnection,
}

export interface ApplicationStatus {
  applicationId: string;
  applicationVersionStatus: ApplicationVersionStatus[];
}

export interface ApplicationVersionStatus {
  applicationVersion: string | null;
  tenantGroupMatchCode: string | null;
  tenantGroupOnline: boolean | null;
  tenantStatus: TenantStatus[] | null;
}

export interface TenantStatus {
  tenantId: string | null;
  tenantOnline: boolean | null;
  legacyVersion: string | null;
  activationGroup: ActivationGroupEnum | null;
}

export enum ActivationGroupEnum {
  CD = 'CD',
  ACC = 'ACC',
  PILOT = 'PILOT',
  PILOT2 = 'PILOT2',
  MASS = 'MASS'
}
